import { loadScript } from '../loadScript'
// import cpSite from '../cpSite'
import config from '../config'

/**
 * Включение библиотеки Yandex SmartCaptcha
 * @param cb {Function} - Функция, которая будет запущено после полной инициализации
 */
const smartcaptcha = {
  state: {
    lib: 'https://smartcaptcha.yandexcloud.net/captcha.js',
    sitekey: config.DEVMODE ? '4Rj2gveSZ9DWDN933ObbXa2dTzUUOZ0eut07BfT3' : '9tmZjG2DzrjyfXDHKfrnZ30FUTeLPE0yQFCGibeI',
    formId: 'captcha',
    containerId: 'captcha-container',
    widgetId: 0, // получается из render (нужен, если используется несколько капч на странице)
    isActive: false
  },
  activate: function (cb = () => false) {
    // Выйти, если повторный запуск капчи
    if (window.smartCaptcha) {
      this.state.isActive = true
      return
    }
    // Проверяем наличие свободного места для загрузки контейнера капчи
    // удобно заранее разместить внутри form и брать window.document.forms.captcha['smart-token'].value после готовности callback-функции
    if (!document.getElementById('captcha') && !document.getElementById(this.state.containerId)) {
      document.body.insertAdjacentHTML('beforeend', '<form id="captcha"><div id="' + this.state.containerId + '"></div></form>')

      const module = this
      window.onloadSmartCaptcha = function () {
        if (!window.smartCaptcha) {
          return
        }
        module.state.isActive = true
        module.state.widgetId = window.smartCaptcha.render(module.state.containerId, {
          sitekey: module.state.sitekey,
          invisible: true,
          callback: cb() || module.defaultRenderCallback()
        })
      }
      loadScript(this.state.lib + '?render=onload&onload=onloadSmartCaptcha') // &onload=onloadSmartCaptcha затем вызывает window.onloadSmartCaptcha
    } else {
      console.error('captcha containers ID are busy')
    }
  },
  defaultRenderCallback () {
    config.DEVMODE ? console.log('widgetId', this.state.widgetId) : ''
  },
  /**
   * Подписка на вызов функции после готовности токена капчи
   * @param successCallback - функция, которая будет вызываться после готовности smartcaptcha.execute()
   * @param errorCallback - функция, которая будет вызываться при ошибке соединения
   */
  activateAndSubscribeCallback: function (successCallback = () => false, errorCallback = () => false) {
    // Функция, которая автоматически запускается после активации капчи
    function captchaInitCallback () {
      const module = this
      setTimeout(function () {
        module.subscribeCallback(successCallback, errorCallback)
      }, 0) // Капча активирована, но объект капчи ещё формируется и не отвечает - откладываем подписку в конец инициализации
    }
    window.cpSite.module.smartcaptcha.activate(captchaInitCallback.bind(this)) // Загрузка и render капчи, получение callback в конце
  },
  subscribeCallback: function (successCallback = () => false, errorCallback = () => false) {
    window.smartCaptcha.subscribe(
      window.cpSite.module.smartcaptcha.state.widgetId, // Создаётся после render
      'success',
      () => successCallback()
    )
    window.smartCaptcha.subscribe(
      window.cpSite.module.smartcaptcha.state.widgetId, // Создаётся после render
      'token-expired',
      () => function () {
        window.smartCaptcha.reset()
        successCallback()
      }
    )
    window.smartCaptcha.subscribe(
      window.cpSite.module.smartcaptcha.state.widgetId, // Создаётся после render
      'network-error',
      () => errorCallback({ message: 'Нет связи с сервером. Попробуйте ещё раз.' })
    )
  }
}
export default smartcaptcha
